<script setup>
const app_config = useAppConfig()
const { offertype } = defineProps({
    offertype: {
        type:  String,  
        default: 'all'
    }
})
</script>
<template>
    <div class="grid md:grid-cols-4 grid-cols-1 w-full gap-6">
        <template v-for="( item, index ) in app_config.naznacheniya">
            <template v-if="offertype == 'all'">
                <div class="flex items-center justify-center w-full  h-[160px] group md:hover:scale-125 z-[6] md:hover:z-10 transition-transform">
                    <div class="relative brightness-50 w-full h-full md:group-hover:brightness-100">
                        <div 
                            :style="{ backgroundImage: `url('${item.image}')` }"
                            class="w-full rounded-xl h-full bg-no-repeat bg-cover bg-center"
                        >
                        </div>
                    </div>
                    <div class="text-white font-bold text-xl absolute z-10 flex items-center justify-center flex-col group-hover:text-opacity-100 ">
                        <span class="group-hover:bg-[#ffffffe3] group-hover:text-brand-grey rounded-lg px-2 text-center">
                            {{ item.header }}
                        </span>
                        <div class="flex gap-4 mt-3 justify-center" v-if="offertype == 'all'" >
                            <nuxt-link :to="`/arenda/vstroenniy-pomeshenia/${item.slug}`" class="text-sm font-light md:hover:underline md:group-hover:bg-brand-primary md:group-hover:text-black md:group-hover:px-2 md:p-0 p-3 md:bg-transparent bg-brand-primary md:text-white text-black md:rounded-none rounded-lg" >Аренда</nuxt-link>
                            <nuxt-link :to="`/prodaja/vstroenniy-pomeshenia/${item.slug}`" class="text-sm font-light md:hover:underline md:group-hover:bg-brand-green md:group-hover:text-black md:group-hover:px-2 md:p-0 p-3 md:bg-transparent bg-brand-green  md:text-white text-black md:rounded-none rounded-lg" >Продажа</nuxt-link>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <nuxt-link :to="`/${offertype}/vstroenniy-pomeshenia/${item.slug}`" class="flex items-center justify-center w-full h-[160px] group md:hover:scale-125 md:hover:z-10 transition-transform">
                    <div class="relative brightness-50 w-full h-full md:group-hover:brightness-100">
                        <div 
                            :style="{ backgroundImage: `url('${item.image}')` }"
                            class="rounded-xl w-full h-full bg-no-repeat bg-cover bg-center"
                        >
                        </div>
                    </div>
                    <div class="text-white font-bold text-xl rounded-lg px-2 absolute z-10 group-hover:bg-[#ffffffe3] group-hover:text-brand-grey ">
                        {{ item.header }}
                        <div class="flex gap-4 mt-3 justify-center" v-if="offertype == 'all'" >
                            <nuxt-link :to="`/arenda/vstroenniy-pomeshenia/${item.slug}`" class="text-sm font-light md:hover:underline md:group-hover:bg-brand-primary md:group-hover:text-black md:group-hover:px-2 md:p-0 p-3 md:bg-transparent bg-brand-primary md:text-white text-black md:rounded-none rounded-lg" >Аренда</nuxt-link>
                            <nuxt-link :to="`/prodaja/vstroenniy-pomeshenia/${item.slug}`" class="text-sm font-light md:hover:underline md:group-hover:bg-brand-green md:group-hover:text-black md:group-hover:px-2 md:p-0 p-3 md:bg-transparent bg-brand-green  md:text-white text-black md:rounded-none rounded-lg" >Продажа</nuxt-link>
                        </div>
                    </div>
                </nuxt-link>
            </template>
        </template>
    </div>
</template>